module.exports = __webpack_public_path__ + "img/47.71a7bed9.jpg";